import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { WysiwygField, Container } from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink } from '@uncinc/react-drupal-core';
import { Button } from '../../../components';
import { ROUTE_ACCOUNT_EDIT } from '../../../config/routes';
import { APP_OPTIONS, SSO_APPLICATION_RISK_MONITOR_NAME } from '../../../config/constants';
import LogoImageVNL from '../../../assets/images/VNL_logo_clean.svg';

import './style.scss';

const UserSuccess = () => {
  const { type } = useParams();
  const { title, text, buttonText, href } = useCorrectValuesForType(type);

  return (
    <Container small>
      <div className="UserSuccess PageMinimal">
        <div className="PageMinimal__top">
          <CoreLink className="Logo" href="https://www.veiligheid.nl">
            <img src={LogoImageVNL} alt="VeiligheidNL" />
          </CoreLink>
          <h1>{title}</h1>
        </div>
        <div className="PageMinimal__content">
          <WysiwygField
            property="schema:text"
            html={text}
          />
          <Button
            className="Button Button--primary"
            {...{ href }}
          >
            {buttonText}
          </Button>
        </div>
      </div>
    </Container>
  );
};

function useCorrectValuesForType(type) {
  const { t } = useTranslation();

  const SUCCESS_TYPES = {
    REGISTER: 'register',
    RESETPASSWORD: 'resetpassword',
    REQUESTPASSWORD: 'requestpassword',
  };

  if (type === SUCCESS_TYPES.REGISTER) {
    return {
      title: t('form.register.success.title'),
      text: t('form.register.success.description'),
      buttonText: t('form.register.success.buttonText'),
      href: '/account/personal',
    };
  }

  if (type === SUCCESS_TYPES.REQUESTPASSWORD) {
    return {
      title: t('request_password.success.title'),
      text: t('request_password.success.description'),
      buttonText: t('login.login_button'),
      href: '/login',
    };
  }

  if (type === SUCCESS_TYPES.RESETPASSWORD) {
    const urlParams = new URLSearchParams(window.location.search);
    const isRiskMonitorUser = urlParams.get('rmUser');
    const riskMonitorLoginUrl = APP_OPTIONS.ssoServices.filter((e) => e.id === SSO_APPLICATION_RISK_MONITOR_NAME)[0].url;

    return {
      title: t('reset_password.success.title'),
      text: t('reset_password.success.body'),
      buttonText: isRiskMonitorUser ? t('reset_password.button_risk_monitor') : t('reset_password.button'),
      href: isRiskMonitorUser ? ROUTE_ACCOUNT_EDIT : riskMonitorLoginUrl,
    };
  }
}

export default UserSuccess;
